import { mergeStyles } from '@fluentui/react';
import { defaultPalette } from '@h2oai/ui-kit';

export const classNameVisuallyHidden = mergeStyles({
  position: 'absolute',
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  width: 1,
  height: 1,
  whiteSpace: 'nowrap',
});

export const classNameLoadingText = mergeStyles({
  color: defaultPalette.gray500,
  fontStyle: 'italic',
});

export const classNameButtonReset = mergeStyles({
  /* Corrects inability to style clickable `input` types in iOS */
  appearance: 'none',
  backgroundColor: 'transparent',
  border: 'none',
  color: 'inherit',
  fontFamily: 'inherit',
  fontSize: 'inherit',
  fontWeight: 'inherit',

  /* Normalize `line-height`. Cannot be changed from `normal` in Firefox 4+. */
  lineHeight: 'normal',
  margin: 0,
  overflow: 'visible',
  padding: 0,
  inlineSize: 'auto',

  /* Corrects font smoothing for webkit */
  WebkitFontSmoothing: 'inherit',
  MozOsxFontSmoothing: 'inherit',

  /* Remove excess padding and border in Firefox 4+ */
  '&::-moz-focus-inner': {
    border: 0,
    padding: 0,
  },

  '&:focus-visible': {
    outline: 'none',
  },
});
